import { render, staticRenderFns } from "./company_config_component.vue?vue&type=template&id=7f3f3b06&scoped=true"
import script from "./company_config_component.vue?vue&type=script&lang=js"
export * from "./company_config_component.vue?vue&type=script&lang=js"
import style0 from "./company_config_component.vue?vue&type=style&index=0&id=7f3f3b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f3b06",
  null
  
)

export default component.exports